var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.4,
    d: "m8.5 15.5 2.086 2.086a2 2 0 0 0 2.828 0L15.5 15.5m-7 0-2.086-2.086a2 2 0 0 1 0-2.828l4.172-4.172a2 2 0 0 1 2.828 0l4.172 4.172a2 2 0 0 1 0 2.828L15.5 15.5m-7 0 2.086-2.086a2 2 0 0 1 2.828 0L15.5 15.5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.c258e6b7edc7e44f9be44c0bfe7f7565.svg";
export { ForwardRef as ReactComponent };